import ACHInfo from './ach-info';

export default ACHInfo;
